import $ from 'jquery'

/* @ngInject */
const mySelectRailway = (
  utils,
  $timeout,
  toaster,
  $$area,
  valueHandler,
  $$railway,
  $$autocomplete
) => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      myArea: '=',
    },

    template: require('./mySelectRailway.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.railways = []
      $scope.areaFieldsOptions = $$area.metadata.fields
      $scope.railwayFieldsOptions = $$railway.metadata.fields

      $scope.$watch('myArea', async (newArea, oldArea) => {
        if (newArea !== oldArea) {
          $scope.railways.splice(0, $scope.railways.length)

          if (valueHandler.isObject($scope.myArea) && valueHandler.isArray($scope.areas)) {
            $scope.myArea = utils.getElementById($scope.areas, $scope.myArea.id)
          }

          if (newArea && oldArea) {
            if (newArea.name !== oldArea.name) {
              $scope.myRailway = null
            }
          } else {
            $scope.myRailway = null
          }

          try {
            const data = {
              areaId: newArea ? newArea.id : null,
            }
            $scope.railways = await $$autocomplete.request.get('number', 'railway', data)
          } catch (error) {
            toaster.error(error)
          }
        }
      })

      $scope.$watch('myRailway.number', async (newValue, oldValue) => {
        if (oldValue !== newValue) {
          if (valueHandler.isString(newValue) && newValue !== '') {
            try {
              $scope.myRailway = await $$railway.request.getByNumber(newValue)
            } catch (error) {
              console.error(error)
            }
          } else if (newValue === '') {
            $scope.myRailway = null
          }
        }
      })
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const response = await $$area.request.getAll()
          scope.areas = response.areas
          $timeout(() => {
            $('select.select-active').material_select()
          })
          if (scope.myArea) {
            scope.myArea = utils.getElementById(scope.areas, scope.myArea.id)
          }
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}

export default mySelectRailway



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/inputs/mySelectRailway.js